import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import * as firebase from 'firebase';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import './expo-list.css';

export default class SampleExpo extends ReactFireComponent {
  constructor(props) {
    super(props);
    this.state = {
      expo: {
        host: ''
      }
    }
  }
  componentDidMount() {
    this.bindAsObject(`/expos/${this.props.expoID}/metadata`, 'expo');
  }
  componentWillUnmount() {
    this.unbind('sample');
  }
  render() {
    if(!this.state.expo) return null;
    console.log(this.state)
    return (
      <div className="sample-expo">
        <span>
          <a href={`https://${this.state.expo.host}`} target="_blank">
            {this.state.expo.host}
            <FontAwesome name="external-link"/>
          </a>
        </span>
        Show Sample
        <span>
          <Link to={`/expos/${this.props.expoID}/properties`}>
            <FontAwesome name="edit"
              style={{color: "#965ba5", cursor: "pointer"}}
              />
          </Link>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/series-list/sample-expo.js